export default __webpack_public_path__ + "store/static/media/klas-2025.6b91faf8.svg";